export default {
	game: {
		maintenance: 'Maintenance',
		maintenance_tip: 'Temporarily unavailable',
		no_more_data: 'No more data',
		search_game_name: 'Search game name...',
		selected: 'Selected',
		type: 'Type',
		all_types: 'All Types',
		secondary: 'Secondary',
		secondary_category: 'Secondary Category',
		no_related_games: 'No related games found',
		reset_all: 'Reset All',
		end_of_list: 'End of List',
		game_details: 'Game Details',
		play: 'Play',
		bonus_cannot_wagered: 'Bonus cannot be wagered',
		entering_game: 'Entering game, please wait...',
		entering_game_short: 'Entering Game...',
		game_types: 'Game Types',
		game_providers: 'Game Providers',
		sign_up: 'Sign Up',
		search: 'Search',
		all_providers: 'All Providers',
		loading: 'Loading...',
		my_bet: 'My Bet'
	}
};